import React from "react";
import "./OrdenCard.css";

import BotonEliminar from "../../../../componentsUI/formularios/button/BotonEliminar.js";

export default function OrdenCard({
  mesaId,
  productos,
  total,
  fecha,
  onDelete,
  onSelected,
  seleccionada,
}) {
  return (
    <div
      className={`orden-card ${seleccionada ? "selected" : ""}`}
      onClick={() => onSelected && onSelected()}
    >
      {/* Fila 1 */}
      <div className="orden-header">
        <h3>Mesa {mesaId}</h3>
        <h3 className="orden-fecha">
          Fecha:{" "}
          {new Date(fecha).toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })}{" "}
          {new Date(fecha).toLocaleTimeString("es-ES", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </h3>
      </div>

      {/* Fila 3 */}
      <ul className="orden-card-lista">
        {productos.map((p) => (
          <li key={p.id} className="orden-card-item">
            <span>{p.nombre}</span>
            <span>Cant: {p.cantidad}</span>
            <span>${p.subtotal.toLocaleString()}</span>
          </li>
        ))}
      </ul>

      {/* Fila 4 */}
      <div className="orden-footer">
        <p className="orden-total">Total: ${total.toLocaleString()}</p>

        <div
          className=""
          onClick={(e) => {
            e.stopPropagation(); // evita seleccionar el card
            onDelete();
          }}
        >
          <BotonEliminar />
        </div>
      </div>
    </div>
  );
}
